export default __webpack_public_path__ + "static/media/6_rastafari.e85a1031.png";